module.exports = __webpack_public_path__ + "img/plano-desenvolvimento-individual.0790ac13.svg";